// extracted by mini-css-extract-plugin
module.exports = {"buttons_style":"ButtonDelete_buttons_style__3rz4O","delete_button":"ButtonDelete_delete_button__2Vheu"};